export default "__VITE_ASSET__CzV$hUrW__"